import React from "react";

function Navigation() {
  return (
    <nav className="flex flex-row justify-between font-family mb-7 items-center px-7 lg:px-0 bg-indigo-900 text-white h-20">
      <h1 className="text-2xl md:text-3xl font-bold text-left lg:text-center sm:mx-auto">
        ✈ My Travel Journal
      </h1>
      <svg
        className="lg:hidden scale-150"
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 5H0V4h16v1zm0 8H0v-1h16v1zm0-4.008H0V8h16v.992z"></path>
      </svg>

      <ul className="hidden lg:flex lg:flex-row lg:justify-between lg:space-x-3 text-xs items-center h-full bg-green-900 p-5">
        <li className="mr-4 ">
          <input
            type="text"
            placeholder="Enter keyword here"
            name="search word"
            id="search-text"
            className="p-2 m-r-5 rounded-md text-green-600"
          ></input>
          <input
            type="submit"
            value="Search!"
            id="search-btn"
            className="ml-1 p-2 bg-green-500 rounded-md cursor-pointer transition duration-700 hover:bg-blue-500"
          />
        </li>
        <li className="hover:border-b-4 transition-all cursor-pointer">
          Other Projects
        </li>
        <li className="hover:border-b-4 cursor-pointer">Contact Me</li>
      </ul>
    </nav>
  );
}

export default Navigation;
